<template>
  <div class="row">
    <div class="col-lg-12">
      <ul class="mb-0">
        <li
          class="li_style_none"
          v-for="(option, index) in question.choices.options"
          :key="index"
        >
          <span
            class="d-inline"
            :class="{
              'font-weight-bold': wasMarked(option.title),
            }"
          >{{
              wasMarked(option.title) ? `* ${option.title}` : option.title
            }}</span>
          <RightOrWrongIcons
            ParentDivClasses="d-inline"
            :hide="!question.choices.rightAnswer.haveOne"
            :useSvg="useSvg"
            :rightIf="
              question.choices.rightAnswer.titles.includes(option.title)
            "
            :wrongIf="
              !question.choices.rightAnswer.titles.includes(option.title) &&
              wasMarked(option.title)
            "
          />
          <span
            v-if="option.hasSubanswer"
          >
            {{ getSubanswers(option) }}
          </span>
        </li>
      </ul>
    </div>
    <div class="col-lg-12">
      <span class="f14">(<b>*</b>) Opção que o candidato(a) marcou</span>
    </div>
  </div>
</template>

<script>
import RightOrWrongIcons from "components/RightOrWrongIcons.vue";

export default {
  props: {
    answer: {
      type: Object,
      default: () => {},
      required: true,
    },
    useSvg: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  components: { RightOrWrongIcons },
  computed: {
    question() {
      return this.answer.question;
    },
  },
  methods: {
    wasMarked(title) {
      if (this.answer.choices == null) {
        return false;
      }
      return this.answer.choices.marked.includes(title);
    },
    getSubanswers(option) {
      if (option.hasSubanswer) {
        const subanswers = this.answer.choices.subanswers.filter(
          (subanswer) => subanswer.parent_option === option.title
        )
        if (subanswers.length > 0)
          return `(${option.subanswerLabel}: ` + subanswers.map((subanswer) => subanswer.marked).join(", ") + ')';
      }
      return "";
    },
  },
};
</script>